<template>
    <sa-page-layout :data="jsonData" :btnBackVisible="true" :btnEditVisible="true" :pathResource="pathResource" :linkback="linkback" :linkedit="linkedit" class="sa-no-space">
        <template slot="table-body">
            <b-tabs id="tabsRsaDiario" ref="tabsRsaDiario" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill>
                <b-tab title="Dati Struttura" active>
                    <div class="sa-tab-scroll">
                        <div class="sa-component-content">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                    <h4>{{ this.$i18n.t("structure.lblClinicRegistry") }}</h4>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <img :src="jsonData.logo" style="width: 10rem" />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblName") }}</label>
                                    <span class="sa-data">{{ jsonData.denominazione }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblRegionCode") }}</label>
                                    <span class="sa-data">{{ jsonData.codiceRegione }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblCompanyCode") }}</label>
                                    <span class="sa-data">{{ jsonData.codiceStruttura }}</span>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblVatNumber") }}</label>
                                    <span class="sa-data">{{ jsonData.partitaIva }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblFiscalCode") }}</label>
                                    <span class="sa-data">{{ jsonData.codiceFiscale }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblIban") }}</label>
                                    <span class="sa-data">{{ jsonData.iban }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblTaxRegime") }}</label>
                                    <span class="sa-data">{{ jsonData.codiceRegimeFiscale }}</span>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblAddress") }}</label>
                                    <span class="sa-data">{{ jsonData.indirizzo }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblProvince") }}</label>
                                    <span class="sa-data">{{ jsonData.provincia }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblCity") }}</label>
                                    <span class="sa-data">{{ jsonData.localita }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblPostalCode") }}</label>
                                    <span class="sa-data">{{ jsonData.cap }}</span>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblTelephoneNumber") }}</label>
                                    <span class="sa-data">{{ jsonData.telefono }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblEmail") }}</label>
                                    <span class="sa-data">{{ jsonData.email }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblFax") }}</label>
                                    <span class="sa-data">{{ jsonData.fax }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblUrl") }}</label>
                                    <span class="sa-data">{{ jsonData.url }}</span>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <label class="sa-label-data">{{ this.$i18n.t("structure.lblNote") }}</label>
                                    <span class="sa-data">{{ jsonData.note }}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-tab>
                <b-tab title="Lista IBAN">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovoIban" class="mb-2">
                                <font-awesome-icon icon="plus"> </font-awesome-icon>
                                Aggiungi
                            </b-button>
                        </b-col>
                    </b-row>
                    <div class="b-table-sticky-header">
                        <b-table sticky-header ref="table" responsive stacked="lg" striped hover :items="jsonData.listaIban" :fields="fields" :current-page="1" :per-page="10000000" sort-icon-left head-variant="light" class="sa-b-table">
                            <template v-slot:cell(denominazione)="{ item }">
                                <router-link class="sa-edit-link" :to="'/struttura/view/' + item.id"> {{ item.denominazione }} </router-link>
                            </template>
                            <template v-slot:cell(logo)="{ item }">
                                <img :src="item.logo" style="width: 3rem" />
                            </template>
                        </b-table>
                    </div>
                </b-tab>
            </b-tabs>
            <b-modal scrollable b-modal ref="mdlNuovoIban" id="mdlNuovoIban" size="md" style="height: 100%" :title="'Aggiungi IBAN'">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Nome Banca</label>
                        <b-form-input v-model="jsonDataNuovoIban.banca" placeholder="Nome Banca"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">IBAN</label>
                        <b-form-input v-model="jsonDataNuovoIban.iban" placeholder="IBAN"></b-form-input>
                    </b-col>
                </b-row>
                <template #modal-footer>
                    <b-button @click="onClickSalva" variant="outline-success">Salva</b-button>
                    <b-button size="md" class="no-text" variant="outline-danger" @click="onClickAnnulla">Annulla</b-button>
                </template>
            </b-modal>
        </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    components: { SaPageLayout },
    mixins: [UtilityMixin],
    data() {
        return {
            linkback: "/strutture",
            pathResource: "/strutture",
            pathResourceIban: "/struttureiban",
            linkedit: null,
            jsonData: {},
            jsonDataNuovoIban: { banca: "", iban: "", idStruttura: "" },
            fields: [
                {
                    label: "Banca",
                    key: "banca",
                    sortable: true,
                    //thStyle: "width: 7rem",
                },
                {
                    label: "IBAN",
                    key: "iban",
                    //thStyle: "width: rem",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: true,
                },
                { class: "sa-table-column-action-single", key: "actions", label: "" },
            ],
        };
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        me.linkedit = "/struttura/edit/" + me.id;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showmolalloading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
            axios.get(link + me.id).then((response) => {
                me.jsonData = response.data.data;
                me.showmolalloading = false;
            });
        },
        onClickNuovoIban() {
            let me = this;
            me.jsonDataNuovoIban = { banca: "", iban: "", idStruttura: me.jsonData.id };
            me.$refs.mdlNuovoIban.show();
        },
        onClickSalva(bvModalEvent) {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResourceIban, me.jsonDataNuovoIban, me.resultResponseSave, me.resultErrorSave);
            bvModalEvent.preventDefault();
        },
        resultResponseSave() {
            let me = this;
            me.jsonDataNuovoIban = { banca: "", iban: "", idStruttura: "" };
            me.$refs.mdlNuovoIban.hide();
            me.loadData();
            // me.$emit("saveSuccess");
        },
        resultErrorSave(error) {
            UtilityMixin.methods.messaggeBoxError(this, error);
        },
        onClickAnnulla() {
            let me = this;
            me.jsonDataNuovoIban = { banca: "", iban: "", idStruttura: "" };
            me.$refs.mdlNuovoIban.hide();
        },
    },
};
</script>
